import { render } from "./VietnamStockWatch.vue?vue&type=template&id=7699c8af&scoped=true"
import script from "./VietnamStockWatch.vue?vue&type=script&lang=js"
export * from "./VietnamStockWatch.vue?vue&type=script&lang=js"

import "./VietnamStockWatch.vue?vue&type=style&index=0&id=7699c8af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7699c8af"]])

export default __exports__